// Constants
import { CasePhaseConstants } from "Constants";
// Enums
import { CasePageEnum, SideNoteTypeEnum } from "Enums";
// Types
import { TCaseState, TSideNoteDTO } from "Types";

export class SideNoteLogic {

    public determineSideNoteType(caseState: TCaseState): SideNoteTypeEnum {
        if(caseState.selectedTechnologyId) {
            return SideNoteTypeEnum.TechnologyNote;
        }

        switch(caseState.selectedEntityName) {
            case CasePageEnum.Intake:
                return SideNoteTypeEnum.IntakeNote;
            case CasePageEnum.Overview:
                if(caseState.casePhase.toLocaleLowerCase() === CasePhaseConstants.PHASE_1.toLowerCase()) {
                    return SideNoteTypeEnum.MidwayTableNote;
                } else {
                    return SideNoteTypeEnum.FinalTableNote;
                }
            case CasePageEnum.RequiremenstTable:
                return SideNoteTypeEnum.FinalTableNote;
            case CasePageEnum.Radar:
                return SideNoteTypeEnum.RadarNote;
            default:
                return SideNoteTypeEnum.None;
        }
    }

    public getSideNotesCount(sideNotes: TSideNoteDTO[]): number {
        let sideNotesCount: number = 0;

        if (!sideNotes) return sideNotesCount;

        for (const sideNote of sideNotes) {
            if (!sideNote) continue;
            sideNotesCount++;

            if (!sideNote.replies) continue;
            sideNotesCount += sideNote.replies.length;
        }

        return sideNotesCount;
    };
}

export const SideNoteLogicSingleton = new SideNoteLogic();